import CardStateHelper, { getCardsState } from '../CardStateHelper';
import BaseCardBehavior from './BaseCardBehavior';
import { CardTask } from '../CardTasks';
import { SCORE_TORNADO_CARD, SCORE_TORNADO_TARGET_CARD } from 'Constants/Score';
import { IGameState } from '../../Game/IGameState';
import { ICardsState, ValueCardData } from '../ICardState';
import CardStateModifierHelper from '../CardStateModifierHelper';

export default class TornadoCardBehavior extends BaseCardBehavior {
    public play(state: IGameState): IGameState {
        let cardsState: ICardsState = state.levelState.cardsState;
        const targets = CardStateHelper.getValueCards(cardsState)
            .filter(cardID => {
                const behavior = CardStateHelper.getCardBehavior(cardsState, cardID);

                // Previously this filter excluded blocked cards that were also face-up. This was changed because blocked face-up cards
                // would simply have there values change abruptly without any animation.
                return behavior.isFaceUp(cardsState);
            })

            // Sort target cards so that blocked cards are not re-parented in front of unblocked cards when the tornado is animated.
            .sort((a, b) => {
                const aIsBlocked = CardStateHelper.getCardBehavior(cardsState, a).isBlocked(cardsState);
                return aIsBlocked ? -1 : 1;
            })
            .map(cardID => ({
                cardID: cardID,
                oldValue: (cardsState.cards[cardID] as ValueCardData).value,
                newValue: null,
            }));

        // Shuffle all in-play value cards.
        cardsState = CardStateHelper.shuffleValueCards(cardsState);

        const scores: number[] = [SCORE_TORNADO_CARD];

        // Set "newValue" after shuffling.
        targets.forEach(target => {
            target.newValue = (cardsState.cards[target.cardID] as ValueCardData).value;
            scores.push(SCORE_TORNADO_TARGET_CARD);
        });

        // Discard this card.
        state = CardStateHelper.updateGameState(state, cardsState);
        state = CardStateHelper.setCardDiscarded(state, this.cardID);
        cardsState = getCardsState(state);

        // Add score.
        cardsState = CardStateHelper.addTurnScore(
            cardsState,
            scores.reduce((a, c) => a + c, 0)
        );

        // Trigger tornado animation task.
        cardsState = CardStateHelper.setStateTaskData(cardsState, {
            task: CardTask.TORNADO,
            cards: [this.cardID, ...targets.map(t => t.cardID)],
            cardsScore: [...scores],
            targets: targets,
        });

        // Clear undo history when a tornado card is played.
        cardsState = CardStateHelper.clearUndoHistory(cardsState);

        state = CardStateHelper.updateGameState(state, cardsState);
        state = CardStateHelper.updateCards(state);
        state = CardStateModifierHelper.onCardPlayed(state, this.cardID);

        return state;
    }
}
